import React,{Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import moment from 'moment';
import "moment/locale/ru";
import * as dashboardActions from '../../../actions/dashboardParserActions';

import Spinner from "../../Shared/Spinner";

moment.locale('ru');

class Parser extends Component{
    constructor(props){
        super(props)
        let {dashboardActions} = this.props;

        dashboardActions.Get();
    }
    handleOnCompanyClick(e,id){
        this.props.history.push(`/dashboard/errors/${id}`)
    }
    render(){
        let {parser} = this.props;
        return(
            <div className="content companies-page">

                {
                    parser.fetching ?
                        <Spinner
                            styles={{
                                backgroundColor: "#37474F"
                            }}
                            className="absolute"
                        />
                        : null
                }

                <div className="table-wrapp">

                    <div className="table-responsive">
                        <table className="table">
                            <thead>
                            <tr>
                                <th>Id</th>
                                <th>Компания</th>
                                <th>Url</th>                                
                                <th>Обработано товаров всего</th>
                                <th>Обработано товаров в наличии</th>    
                                <th>Всего товаров в наличии</th>
                                <th>Всего товаров</th>                            
                                <th>Последняя обработка цен</th>   
                                <th>Ранняя дата товара в наличии</th>                             
                            </tr>
                            </thead>
                            <tbody>
                            {
                                parser.data.length > 0 ?
                                    parser.data.map((parser, index) => {
                                        return (
                                            <tr key={index} className="no-pointer" onClick={(e)=>this.handleOnCompanyClick(e,parser.id)}>
                                                <td>{parser.id}</td>
                                                <td>{parser.name}</td>
                                                <td>
                                                    <a href={parser.url} target="_blank" title="открыть в новом окне">{parser.url}</a>
                                                </td>
                                                <td>
                                                    {parser.count}
                                                </td>
                                                <td>
                                                    {parser.offersAvailableCount}
                                                </td>
                                                <td>
                                                    {parser.totalAvailableOffersCount}
                                                </td>
                                                <td>
                                                    {parser.totalOffersCount}
                                                </td>
                                                <td>{moment(parser.lastUpdate).format('DD.MM.YYYY hh:mm')}</td>    
                                                <td>{moment(parser.activeOfferFirstDate).format('DD.MM.YYYY hh:mm')}</td>                                              
                                                
                                            </tr>
                                        );
                                    })
                                    : parser.set ?
                                    <tr>
                                        <td colSpan="4">
                                            Нет данных
                                        </td>
                                    </tr>
                                    :null
                            }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return{
        parser:state.parser
    }
}

function mapDispatchToProps(dispatch) {
    return{
        dashboardActions:bindActionCreators(dashboardActions,dispatch)
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Parser);


// WEBPACK FOOTER //
// ./src/components/Dashboard/Parser/index.jsx